export const getBackendUrl = () => localStorage.getItem('backendUrl') || 'localhost:3000/';

export const getSsl = () => localStorage.getItem('ssl') === 'true';

export const getUrl = () => `${getSsl() ? 'https' : 'http'}://${getBackendUrl()}`;
